module.exports = __webpack_public_path__ + "static/scale-model-of-tempe-arizona-bfe721423a165f0d23226fbc8d6df65e.png";